/**
 * Route paths for the performance guarantee module.
 * Single source of truth — reuse these instead of hard-coding `/performance-guarantee...` strings.
 */
export const PERFORMANCE_GUARANTEES_ROUTES = {
  root: "/performance-guarantee",
  details: "/performance-guarantee/:id",
} as const;

export const PgTableColumns = [
  { field: "sl", headerName: "Sl No", flex: 0.8, sortable: false },
  {
    field: "name",
    headerName: "Name",
    flex: 2,
    sortable: true,
  },
  {
    field: "projectName",
    headerName: "Project Name",
    flex: 2,
    sortable: false,
  },
  {
    field: "description",
    headerName: "Description",
    flex: 1.5,
    sortable: true,
  },
  {
    field: "depositAmount",
    headerName: "Amount",
    flex: 1,
    sortable: true,
  },
];
